import { ExclamationCircleIcon } from "@heroicons/react/24/outline";
import { XMarkIcon } from "@heroicons/react/24/solid";
import { useState } from "react";

interface ErrorMessageProps {
  message: string;
  icon?: boolean;
  dismissible?: boolean;
  onDismiss?: () => void;
}

export function ErrorMessage({
  message,
  icon = true,
  dismissible,
  onDismiss,
}: ErrorMessageProps) {
  const [isVisible, setIsVisible] = useState(true);

  if (!isVisible) return null;
  return (
    <div className="bg-red-100 border-l-4 border-red-500 p-4 rounded-r-lg flex items-start gap-3">
      {icon && (
        <ExclamationCircleIcon className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" />
      )}
      <div className="flex-grow text-red-700">{message}</div>
      {dismissible && (
        <button
          onClick={() => {
            setIsVisible(false);
            onDismiss?.();
          }}
          className="text-red-400 hover:text-red-500"
        >
          <XMarkIcon className="w-5 h-5" />
        </button>
      )}
    </div>
  );
}
